import React from 'react';
import PropTypes from 'prop-types';

const BadgeInput = (
  {
    onFocus,
    onKeyUp,
    onChange,
    value,
    disabled,
    placeholderText,
    defaultValue,
    tabIndex,
  },
  ref,
) => (
  <input
    data-testid="fbb-input"
    autoComplete="off"
    defaultValue={defaultValue}
    tabIndex={tabIndex}
    placeholder={placeholderText}
    disabled={disabled}
    ref={ref}
    value={value}
    onFocus={onFocus}
    onKeyUp={onKeyUp}
    onChange={onChange}
  />
);

const forwardBadgeInput = React.forwardRef(BadgeInput);

BadgeInput.propTypes = {
  onFocus: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  placeholderText: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tabIndex: PropTypes.number,
};

BadgeInput.defaultProps = {
  disabled: true,
  tabIndex: 6,
  placeholderText: '',
  defaultValue: '',
};

export default forwardBadgeInput;
